import drawLabelLLCQR from '../helpers/drawLabelLLCQR'
import drawLabelLLC from '../helpers/drawLabelLLC'
import drawLabelTeddy4Life from '../helpers/drawLabelTeddy4Life'
import drawLabelSBFAST from './drawLabelSBFAST'

// Resolve nguồn label của đơn để hiển thị preview giống hệt bản sẽ in.
// Tái dùng đúng nhánh phân loại theo order_type + shipping_carrier như ShipOrderDetails._printLabel.
// - Trả về dataURL (label hệ thống vẽ) hoặc url (label thật) nếu tạo được label.
// - Trả về null khi đơn chưa có label (kể cả draw-type nhưng thiếu tracking number/lô ship để vẽ).
const resolveShipLabel = async (item) => {
    if (!item) return null

    const {
        labelDetails, order_type, split_fba_item_label,
        first_barcode_in_batch_ship, first_batch_ship_box, barcodeNumber, tags = []
    } = item
    const { url, shipping_carrier, partnerTrackingNumber, trackingNumber } = { ...labelDetails }

    // SB_FAST theo lô ship — vẽ canvas (áp dụng cả đơn thường lẫn đơn gộp)
    if (first_barcode_in_batch_ship && first_batch_ship_box) {
        const { labelDetails: batchLabelDetails } = { ...first_barcode_in_batch_ship }
        const { shipping_carrier: batchCarrier } = { ...batchLabelDetails }
        if (batchCarrier === 'SB_FAST') {
            return await drawLabelSBFAST(first_barcode_in_batch_ship, first_batch_ship_box)
        }
    }

    // FBA — ảnh label tách sẵn (label thật)
    if (order_type === 'FBA') {
        return split_fba_item_label || null
    }

    // Các carrier hệ thống tự vẽ label — cần tracking number để vẽ được label hoàn chỉnh
    if (shipping_carrier === 'flashship_usps' || shipping_carrier === 'flashship_usps_manual' || shipping_carrier === 'GC_LLC') {
        return partnerTrackingNumber ? await drawLabelLLCQR(item) : null
    }

    if (shipping_carrier === 'ib_blue') {
        return partnerTrackingNumber ? await drawLabelLLC(barcodeNumber, partnerTrackingNumber, 'ib_blue') : null
    }

    if (shipping_carrier === 'teddy_4_life') {
        return trackingNumber ? await drawLabelTeddy4Life({ trackingNumber, barcodeNumber }) : null
    }

    // Carrier thường — label thật dạng url (ảnh/PDF)
    if (!url) return null

    let labelFile = url
    const hasShipByTiktokTag = tags.some(tag => tag === 'shipbytiktok')
    if (hasShipByTiktokTag && url.includes('s3.us-west-1.amazonaws.com')) {
        labelFile = url.replace('https://merchize-artworks.s3.us-west-1.amazonaws.com', 'https://d22stb37tnopyt.cloudfront.net')
    }

    return labelFile
}

export default resolveShipLabel
